import { ENG, CH } from "../../constants"

let dictionary = {}

dictionary[ENG] = {
    NAME: "Wei Fan, Chang ",
    INTRO1:
        "graduated from department of Materials Science and Engineering and finally found her passion in Computer Science. When working in a social enterprise as an intern, she got to notice the responsibility of a human being and aim to contribute to the community.",

    INTRO2:
        "She had been a fullstack engineer for one year before going to graduate school. She received her Master Degree in Computer Science from National Taiwan University. After graduating, she gained experience as a Machine Learning Engineer at Shopee and Apple in Singapore. Currently, she is a Software Engineer at Google, having joined in March 2025."
}

dictionary[CH] = {
    NAME: "張葳凡",
    INTRO1:
        "，現在就讀於台大資訊工程研究所，在前往寫程式的路上繞了點路。大學時就讀材料科學與工程學系，偶然發現電腦科學的樂趣，時不時跑去資工系修課，現在變成了資工人。",
    INTRO2:
        "曾經在社會企業當工程師實習生，精進技術的同時，許下了回饋社會的承諾。後來當了一年的網站全端工程師。於台大資訊工程研究所畢業後，曾前往新加坡擔任 Shopee 與 Apple 的機器學習工程師。目前於 Google 擔任軟體工程師 (2025/03 ~)。"
}

export default dictionary
